import { render } from "./CreateProduct.vue?vue&type=template&id=00c64c35&scoped=true"
import script from "./CreateProduct.vue?vue&type=script&lang=js"
export * from "./CreateProduct.vue?vue&type=script&lang=js"

import "./CreateProduct.vue?vue&type=style&index=0&id=00c64c35&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c64c35"]])

export default __exports__